import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE = "updateSELLERADDRESSESTableStructure";
export const UPDATE_TABLE_DATA = "updateSELLERADDRESSESTableData";
export const EXPORT_TABLE_DATA = "exportSELLERADDRESSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSELLERADDRESSESTableStructure";
export const SET_TABLE_DATA = "setSELLERADDRESSESTableData";
export const SET_TABLE_FILTER = "setSELLERADDRESSESTableFilter";
export const SET_TABLE_PAGE = "setSELLERADDRESSESTablePage";
export const SET_TABLE_PERPAGE = "setSELLERADDRESSESTablePerPage";
export const SET_TABLE_SORTBY = "setSELLERADDRESSESTableSortBy";
export const SET_TABLE_SORTORDER = "setSELLERADDRESSESTableSortOrder";
export const SET_EXPORT_LINK = "setSELLERADDRESSESExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getSELLERADDRESSESTableProperties(state) {
    return state.table_structure.properties;
  },
  getSELLERADDRESSESTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSELLERADDRESSESTableState(state) {
    return state.table_state;
  },

  getSELLERADDRESSESTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSELLERADDRESSESTableFilters(state) {
    return state.table_structure.filters;
  },

  getSELLERADDRESSESTableData(state) {
    return state.table_data.data;
  },
  getSELLERADDRESSESExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/authorizations/seller_addresses")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    // state.page_loading = true;
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post("/authorizations/seller_addresses/datatable", payload)
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          // state.page_loading = false;
          setTimeout(() => {
            window.scrollTo(0, 0);
            context.commit(SET_PAGE_LOADING, false);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/authorizations/seller_addresses/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
